import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Component as AssetCTA } from '../AssetCTA';

const TemplateButtonContainer = styled.div`
  ${props =>
    props.fullWidth &&
    `
    display: flex;
    flex-direction: column;
  `};
`;

const StyledAssetCTA = styled(AssetCTA)`
  margin-top: ${props => props.theme.spacing.small}px;

  ${props =>
    props.large &&
    `
    font-size: 16px;
    padding: ${props => props.theme.spacing.moderate}px;
  `};
`;

export default class TemplateButtons extends React.PureComponent {
  static propTypes = {
    asset: PropTypes.object.isRequired,
    fullWidth: PropTypes.bool,
    largeButton: PropTypes.bool,
  };

  static defaultProps = {
    fullWidth: true,
    largeButton: true,
  };

  renderButton(text, url, theme) {
    if (text && url) {
      return (
        <StyledAssetCTA
          large={this.props.largeButton}
          options={{
            customVars: { ctaUrl: url, ctaText: text, ctaTheme: theme },
          }}
        />
      );
    }
    return null;
  }

  render() {
    const { asset, fullWidth } = this.props;
    const {
      ctaText1,
      ctaText2,
      ctaText3,
      ctaTheme1,
      ctaTheme2,
      ctaTheme3,
      ctaUrl1,
      ctaUrl2,
      ctaUrl3,
    } = asset.options.customVars;

    return (
      <TemplateButtonContainer fullWidth={fullWidth}>
        <StyledAssetCTA {...asset} onClick={this.props.trackButtonClick} />
        {this.renderButton(ctaText1, ctaUrl1, ctaTheme1)}
        {this.renderButton(ctaText2, ctaUrl2, ctaTheme2)}
        {this.renderButton(ctaText3, ctaUrl3, ctaTheme3)}
      </TemplateButtonContainer>
    );
  }
}
